import { motion, useReducedMotion } from "framer-motion";

const OFFSETS = {
  up: { x: 0, y: 20 },
  left: { x: -50, y: 0 },
  right: { x: 50, y: 0 },
};

const Reveal = ({ children, delay = 0, direction = "up", className = "" }) => {
  const prefersReducedMotion = useReducedMotion();
  const { x, y } = OFFSETS[direction] ?? OFFSETS.up;

  // With reduced motion the content still fades in, but without travelling
  // across the screen and without the stagger delay — the movement is the
  // part that causes trouble, not the opacity change.
  const initial = prefersReducedMotion
    ? { opacity: 0, x: 0, y: 0 }
    : { opacity: 0, x, y };

  return (
    <motion.div
      initial={initial}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{
        duration: prefersReducedMotion ? 0.2 : 0.5,
        delay: prefersReducedMotion ? 0 : delay,
        ease: "easeOut",
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
